/* eslint-disable no-underscore-dangle */
import { ENVIRONMENTS, HUB_BACKEND_ENVIRONMENTS } from '~/main/environments';

import type { Store } from '@reduxjs/toolkit';
import type { LoggerScope } from '~/main/utils/logger';
import type { AppState } from '~/renderer/store/types';

export enum AutoUpdateStatus {
  DOWNLOADING = 'downloading',
  DOWNLOADED = 'downloaded',
}

class Session {
  private _hubWindow: Electron.BrowserWindow | null;
  private _cfdWindow: Electron.BrowserWindow | null;
  private _outlineWindow: Electron.BrowserWindow | null;
  private _licenseWindow: Electron.BrowserWindow | null;
  private _offscreenWindow: Electron.BrowserWindow | null;
  private _baseUrl: string;
  private _autoUpdateStatus: AutoUpdateStatus | null;
  private _isManualCheckForUpdates: boolean;
  private _tray: Electron.Tray | null;
  private _menu: Electron.Menu | null;
  private _store: Store<AppState>;
  private _environment: ENVIRONMENTS | undefined;
  private _hubBackendEnvironment: HUB_BACKEND_ENVIRONMENTS | undefined;
  private _enabledLoggerScopes: LoggerScope[] | '*' | 'none';

  constructor() {
    this._hubWindow = null;
    this._cfdWindow = null;
    this._outlineWindow = null;
    this._licenseWindow = null;
    this._offscreenWindow = null;
    this._menu = null;
    this._tray = null;
    this._baseUrl = '';
    this._autoUpdateStatus = null;
    this._isManualCheckForUpdates = false;
    this._store = {} as Store<AppState>;
    this._environment = ENVIRONMENTS.BUNDLED;
    this._enabledLoggerScopes = 'none';
  }

  get hubWindow() {
    return this._hubWindow;
  }

  set hubWindow(hubWindow) {
    this._hubWindow = hubWindow;
  }

  get cfdWindow() {
    return this._cfdWindow;
  }

  set cfdWindow(cfdWindow) {
    this._cfdWindow = cfdWindow;
  }

  get outlineWindow() {
    return this._outlineWindow;
  }

  set outlineWindow(outlineWindow) {
    this._outlineWindow = outlineWindow;
  }

  get licenseWindow() {
    return this._licenseWindow;
  }

  set licenseWindow(licenseWindow) {
    this._licenseWindow = licenseWindow;
  }

  get offscreenWindow() {
    return this._offscreenWindow;
  }

  set offscreenWindow(offscreenWindow) {
    this._offscreenWindow = offscreenWindow;
  }

  get baseUrl() {
    return this._baseUrl;
  }

  set baseUrl(baseUrl) {
    this._baseUrl = baseUrl;
  }

  get autoUpdateStatus() {
    return this._autoUpdateStatus;
  }

  set autoUpdateStatus(autoUpdateStatus) {
    this._autoUpdateStatus = autoUpdateStatus;
  }

  get isManualCheckForUpdates() {
    return this._isManualCheckForUpdates;
  }

  set isManualCheckForUpdates(isManualCheckForUpdates) {
    this._isManualCheckForUpdates = isManualCheckForUpdates;
  }

  get environment() {
    return this._environment;
  }

  set environment(environment) {
    this._environment = environment;
  }

  get hubBackendEnvironment() {
    return this._hubBackendEnvironment;
  }

  set hubBackendEnvironment(hubBackendEnvironment) {
    this._hubBackendEnvironment = hubBackendEnvironment;
  }

  get menu() {
    return this._menu;
  }

  set menu(menu) {
    this._menu = menu;
  }

  get tray() {
    return this._tray;
  }

  set tray(tray) {
    this._tray = tray;
  }

  get store() {
    return this._store;
  }

  set store(store) {
    this._store = store;
  }

  get enabledLoggerScopes() {
    return this._enabledLoggerScopes;
  }

  set enabledLoggerScopes(enabledLoggerScopes) {
    this._enabledLoggerScopes = enabledLoggerScopes;
  }
}

export default new Session();
